// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__Q_UEp","approved":"Status_approved__2Vmpz","rejected":"Status_rejected__26CH2","expired":"Status_expired__38UgX","label":"Status_label__1qwrv"};